import type { Maybe } from '@adornis/base/utilTypes.js';
import {
  RegistrationController,
  registrationControllerContext,
} from '@adornis/bh-registration/client/bh-registration-controller.js';
import { BuchungsheldLitElement } from '@adornis/buchungsheld-components/BuchungsheldLitElement.js';
import '@adornis/buchungsheld-theme/components/index.js';
import '@adornis/chemistry/elements/components/x-button.js';
import { consume } from '@lit/context';
import { html, nothing, type PropertyValues, type TemplateResult } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { BehaviorSubject } from 'rxjs';

@customElement('bh-page-registration-subpage')
export class BHRegistrationFlowSubPage extends BuchungsheldLitElement {
  @consume({ context: registrationControllerContext })
  @state()
  readonly _registrationController!: RegistrationController;

  protected _registrationController$ = new BehaviorSubject<RegistrationController | null>(null);

  protected backAction: Maybe<() => Promise<void> | void>;
  protected nextAction: Maybe<() => Promise<void> | void>;
  @state() protected nextButtonDisabled = false;
  @state() protected tooltip?: string;
  @state() protected nextButtonText = ['next'];
  @state() protected backButtonText = ['back'];

  protected override willUpdate(_changedProperties: PropertyValues): void {
    if (this._registrationController !== this._registrationController$.value)
      this._registrationController$.next(this._registrationController);
  }

  content(): TemplateResult {
    throw new Error('should be overriden');
  }

  override render() {
    return html`
      <x-flex space="md">
        ${this.content()}

        <x-flex horizontal space-between crossaxis-center>
          ${this.backAction
            ? html`
                <x-button @click=${this.backAction} mode="outline">
                  ${this._translation.translate(...this.backButtonText)}
                </x-button>
              `
            : html` <div></div> `}
          ${this.nextAction
            ? html`
                <x-flex>
                  <x-button @click=${this.nextAction} ?disabled=${this.nextButtonDisabled}>
                    ${this._translation.translate(...this.nextButtonText)}
                  </x-button>
                  ${this.tooltip ? html`<tr-tooltip .text=${this.tooltip}></tr-tooltip>` : nothing}
                </x-flex>
              `
            : html` <div></div> `}
        </x-flex>
      </x-flex>
    `;
  }
}
